import { ContainerIcon } from 'lucide-react';
import pluralize from 'pluralize';

import { Text } from '@/components/text';
import { Tooltip } from '@/components/tooltip';
import { ShipmentModel } from '@/lib/models/shipment/types';
import { tv } from '@/utils/styles';

export interface ContainerListProps {
  shipments: ShipmentModel[];
  onClickDetails?: (value: ShipmentModel) => void;
}

const ContainerLabel = ({ shipment }: { shipment: ShipmentModel }) => {
  return (
    <>
      <ContainerIcon size={14} className="text-lightBlue-600" />
      <Text className="!m-0 inline text-baseSm">{shipment.containerNumber}</Text>
    </>
  );
};
const ContainerList = ({ shipments, onClickDetails }: ContainerListProps) => {
  const { button, base, labelWrapper } = styles();

  return (
    <div className={base()}>
      <span className={button()}>
        {shipments.length} {pluralize('container', shipments.length)}
      </span>
      <ul className="space-y-3">
        {shipments.map((shipment) =>
          onClickDetails ? (
            <Tooltip trigger={['hover']} placement="left" content="Click for more information" key={shipment.id}>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <button
                type="button"
                onClick={() => (onClickDetails ? onClickDetails(shipment) : undefined)}
                className={labelWrapper({ isButton: true })}
              >
                <ContainerLabel shipment={shipment} />
              </button>
            </Tooltip>
          ) : (
            <div className={labelWrapper()} key={shipment.id}>
              <ContainerLabel shipment={shipment} />
            </div>
          ),
        )}
      </ul>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'space-y-2',
    button: 'justify-self-start text-baseSm text-lightBlue-500 transition-all duration-200',
    labelWrapper: 'flex items-center gap-2',
  },
  variants: {
    isButton: {
      true: {
        labelWrapper: 'underline hover:no-underline',
      },
    },
  },
});

export { ContainerList };
